import { useEffect, useState } from "react";
import { Plus, Trash2 } from "lucide-react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { PhotoField } from "@/components/Uploads";

const PRI = ["", "High", "Medium", "Low"];
export const FIELDS = {
  survey: [["area", "Area"], ["device", "Device"], ["condition", "Condition", ["", "Good", "Fair", "Poor"]], ["issue", "Issue Found", null, true], ["impact", "Impact", null, true], ["recommendation", "Recommendation", null, true], ["priority", "Priority", PRI]],
  mreport: [["device", "Perangkat", ["CCTV", "NVR", "HDD", "Switch", "Lainnya"]], ["location", "Lokasi"], ["status", "Status", [["ok", "OK"], ["nok", "Tidak OK"]]], ["notes", "Notes (jika tidak OK)", null, true], ["issue", "Issue Found", null, true], ["impact", "Impact", null, true], ["recommendation", "Recommendation", null, true], ["priority", "Priority", PRI]],
  checklist: [["name", "Material / Product", null, true], ["qty", "Qty"], ["unit", "Unit"], ["status", "Status", [["", "-"], ["ada", "Ada"], ["tidak", "Tidak Ada"]]], ["note", "Keterangan", null, true]],
};
const BLANK = { survey: { condition: "" }, mreport: { device: "CCTV", status: "ok" }, checklist: { status: "" } };

const Cell = ({ f, r, set, i, devices }) => {
  const [k, label, opts, wide] = f;
  const cls = "h-9 w-full rounded-md border border-slate-200 bg-white px-2 text-sm";
  if (k === "device" && devices) {
    const list = devices.includes("Lainnya") ? devices : [...devices, "Lainnya"];
    const sel = list.includes(r.device) ? r.device : "Lainnya";
    return (
      <label className="space-y-1">
        <span className="text-[11px] font-semibold uppercase text-slate-500">{label}</span>
        <select className={cls} value={sel} onChange={(e) => set({ device: e.target.value })} data-testid={`row-${i}-device`}>{list.map((o) => <option key={o} value={o}>{o}</option>)}</select>
        {sel === "Lainnya" && <Input className="bg-white h-9" placeholder="Ketik nama perangkat..." value={r.device === "Lainnya" ? "" : r.device || ""} onChange={(e) => set({ device: e.target.value || "Lainnya" })} data-testid={`row-${i}-device-other`} />}
      </label>
    );
  }
  return (
    <label className={`space-y-1 ${wide ? "sm:col-span-2" : ""}`}>
      <span className="text-[11px] font-semibold uppercase text-slate-500">{label}</span>
      {opts ? <select className={cls} value={r[k] ?? ""} onChange={(e) => set({ [k]: e.target.value })} data-testid={`row-${i}-${k}`}>{opts.map((o) => { const [v, l] = Array.isArray(o) ? o : [o, o || "-"]; return <option key={v} value={v}>{l}</option>; })}</select>
        : <Input className="bg-white" value={r[k] ?? ""} onChange={(e) => set({ [k]: e.target.value })} data-testid={`row-${i}-${k}`} />}
    </label>
  );
};

export const TechRows = ({ type, rows, setRows }) => {
  const [devices, setDevices] = useState(null);
  useEffect(() => { if (type === "mreport") api.get("/settings").then((r) => setDevices(r.data.tech_devices?.length ? r.data.tech_devices : null)).catch(() => {}); }, [type]);
  const blank = type === "mreport" && devices ? { ...BLANK.mreport, device: devices[0] } : BLANK[type];
  const upd = (i, p) => setRows(rows.map((r, n) => (n === i ? { ...r, ...p } : r)));
  return (
    <div className="space-y-3" data-testid="tech-rows">
      {rows.map((r, i) => (
        <div key={i} className={`rounded-xl border p-3 ${r.status === "nok" || r.status === "tidak" ? "border-rose-200 bg-rose-50/50" : "border-slate-200 bg-slate-50/60"}`} data-testid={`tech-row-${i}`}>
          <div className="mb-2 flex items-center justify-between text-xs font-bold text-slate-500">#{i + 1}
            <div className="flex items-center gap-2">
              {type !== "checklist" && <PhotoField value={r.photo} onChange={(p) => upd(i, { photo: p })} testId={`row-${i}-photo`} />}
              <Button type="button" size="icon" variant="ghost" className="h-7 w-7 text-rose-500" onClick={() => setRows(rows.filter((_, n) => n !== i))} data-testid={`row-${i}-delete`}><Trash2 className="h-4 w-4" /></Button>
            </div>
          </div>
          <div className="grid gap-2 sm:grid-cols-4">{FIELDS[type].map((f) => <Cell key={f[0]} f={f} r={r} i={i} devices={devices} set={(p) => upd(i, p)} />)}</div>
        </div>
      ))}
      <Button type="button" variant="outline" size="sm" onClick={() => setRows([...rows, { ...blank }])} data-testid="tech-row-add-btn"><Plus className="h-4 w-4 mr-1" />Tambah Baris</Button>
    </div>
  );
};
